import { render } from "./externalAlarmInput.vue?vue&type=template&id=796f3acc"
import script from "./externalAlarmInput.vue?vue&type=script&lang=js"
export * from "./externalAlarmInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__